/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Modal, ModalBody, ModalContent, ModalHeader, Select, SelectItem, Spinner, Textarea, User } from '@nextui-org/react';
import { IconArrowLeft, IconUserCircle, IconUsers, IconMoodCheck, IconMoodAngry } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { classNames, fromPhotos } from '../../../../utils';
import { TeacherStudentSerivce, TeacherConductService, TeacherAttendeceService } from '../../../../services';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const CALIFICATION = {
  INDIVIDUAL: 1,
  GROUP: 2,
}

const MOOD_TYPE = {
  BAD: 0,
  GOOD: 1,
}


const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
}

const getIcon = (mood) => {
  switch (mood) {
    case MOOD_TYPE.GOOD:
      return { icon: <IconMoodCheck />, color: 'bg-green' };
    case MOOD_TYPE.BAD:
      return { icon: <IconMoodAngry />, color: 'bg-danger' };
    default:
      return { icon: <IconMoodCheck />, color: 'text-green' };
  }
}

const ConductsCreate = () => {
  const [selectedItem, setSelectedItem] = useState();
  const [description, setDescription] = useState('');
  const [type, setType] = useState(MOOD_TYPE.GOOD);
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const navigate = useNavigate();
  const location = useLocation();
  const { filterBy, grades, isLoading, sections, onSaveGroup, lapses, students, filters, reload, onSaveIndividual } = useFetchTable(location.state);

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reload();
  }

  const onSelectItem = (item, action) => {
    setSelectedItem(item);
    setModalAction(action);
  }


  return (
    <div className='flex flex-col'>
      <Modal
        size="md"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.CREATE) return (
              <ModalCreateConduct
                item={selectedItem}
                onSuccess={() => closeModal()}
                onSaveIndividual={onSaveIndividual}
              />
            )
          }}
        </ModalContent>
      </Modal>

      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}


      <div className="flex gap-4">
        <IconArrowLeft className="cursor-pointer" onClick={() => navigate('/conduct', { replace: true })} />
        <span className="font-bold text-secondary capitalize">{location?.state?.name} - {location?.state?.school_grade?.name}</span>
      </div>

      <main className='mt-5'>
        <Filters
          filterBy={filterBy}
          grades={grades}
          sections={sections}
          lapses={lapses}
        />

        {/* <div className='mt-5 flex items-center gap-4'>
          <Buttons
            isActive={filters.calification === CALIFICATION.INDIVIDUAL}
            onClick={() => filterBy(CALIFICATION.INDIVIDUAL, 'calification')}
            icon={<IconUserCircle />}
            label="Individual"
          />

          <Buttons
            isActive={filters.calification === CALIFICATION.GROUP}
            onClick={() => filterBy(CALIFICATION.GROUP, 'calification')}
            icon={<IconUsers />}
            label="Grupal"
          />
        </div> */}

        <div className='mt-5'>
          <div className='rounded-t-lg bg-foreground-500 text-white p-2'>
            <p>Estudiantes</p>
          </div>


          {
            filters.calification === CALIFICATION.INDIVIDUAL &&
            students.map((user, userIdx) => (
              <div
                key={user.id}
                className="grid grid-cols-4 [&>div]:px-2 border-t border-t-foreground-300"
              >
                <div className="col-span-2 bg-foreground-200 p-2">
                  <User
                    avatarProps={{ showFallback: true, radius: 'full', src: user?.photo ? fromPhotos(user.photo) : null }}
                    name={user?.fullname}
                    classNames={{ description: 'text-foreground-500' }}
                  />
                </div>
                <div className="flex justify-center items-center">
                  <IconMood
                    isActive={true}
                    mood={MOOD_TYPE.GOOD}
                    onClick={() => onSelectItem({ ...filters, student_id: user.id, type: MOOD_TYPE.GOOD }, MODAL_ACTION.CREATE)}
                  />
                </div>
                <div className="flex justify-center items-center">
                  <IconMood
                    isActive={true}
                    mood={MOOD_TYPE.BAD}
                    onClick={() => onSelectItem({ ...filters, student_id: user.id, type: MOOD_TYPE.BAD }, MODAL_ACTION.CREATE)}
                  />
                </div>
              </div>
            ))
          }

          {

            filters.calification === CALIFICATION.GROUP &&
            <div className='bg-white p-4 rounded-b-lg'>
              <div className='flex items-center gap-4 mb-4'>
                <IconMood
                  mood={MOOD_TYPE.GOOD}
                  onClick={() => setType(MOOD_TYPE.GOOD)}
                  isActive={type === MOOD_TYPE.GOOD}
                />
                <IconMood
                  mood={MOOD_TYPE.BAD}
                  onClick={() => setType(MOOD_TYPE.BAD)}
                  isActive={type === MOOD_TYPE.BAD}
                />
              </div>

              <Textarea
                placeholder='Escribir'
                radius="sm"
                variant="bordered"
                value={description}
                onValueChange={v => setDescription(v)}
              />

              <Button
                className='bg-green text-white mt-5'
                onClick={() => onSaveGroup({ ...filters, type, description })}
              >
                Guardar
              </Button>
            </div>
          }
        </div>

      </main>
    </div>
  )
}


const ModalCreateConduct = ({ item, onSuccess, onSaveIndividual }) => {

  const [description, setDescription] = useState('');


  const save = async () => {
    await onSaveIndividual({ ...item, description })
    onSuccess()
  }

  return (
    <>
      <ModalHeader className="flex gap-4 text-secondary items-center">
        <IconMood isActive={true} mood={item?.type} />
        <span className="font-bold">Descripción</span>
      </ModalHeader>
      <ModalBody className="gap-8">

        <Textarea
          placeholder='Escribir'
          radius="sm"
          variant="bordered"
          value={description}
          onValueChange={v => setDescription(v)}
        />


        <Button
          className='bg-green text-white'
          onClick={save}
        >
          Guardar
        </Button>

      </ModalBody>
    </>
  )
}

const Buttons = ({ isActive, onClick, icon, label }) => {
  return (
    <Button
      className={classNames(
        "w-full md:max-w-[10rem]",
        isActive ? "bg-green border-green text-white" : "bg-white"
      )}
      variant="bordered"
      radius="sm"
      onClick={onClick}
      startContent={icon}
    >
      {label}
    </Button>
  );
};

const IconMood = ({ mood, onClick, isActive }) => {

  const { icon, color } = getIcon(mood);

  return (
    <div
      className={classNames(
        'text-white p-1 rounded-lg h-8 w-8 flex justify-center items-center cursor-pointer',
        isActive ? color : 'bg-foreground-300'
      )}
      onClick={onClick}
    >
      {icon}
    </div>
  );
}




const Filters = ({ filterBy, grades, sections, lapses }) => {
  const initialFilter = {
    school_grade_id: '',
    school_section_id: '',
    school_lapse_id: '',
  };
  const [form, setForm] = useState(initialFilter);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
    filterBy(value, target);
  }


  return (
    <section className='flex items-center gap-4 w-[50%]'>
      <Select
        label="Sección"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_section_id ? [form.school_section_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_section_id')}
      >
        {sections.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>

      <Select
        label="Lapso"
        labelPlacement="outside"
        placeholder=" "
        variant="bordered"
        radius="sm"
        classNames={{
          label: 'font-semibold',
          base: 'w-full',
          trigger: 'border-1',
        }}
        disallowEmptySelection={true}
        selectedKeys={!!form.school_lapse_id ? [form.school_lapse_id] : []}
        onSelectionChange={v => onChange(v.currentKey, 'school_lapse_id')}
      >
        {lapses.map((item) => (
          <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
        ))}
      </Select>
    </section>
  )
}

const useFetchTable = (subject) => {

  const initialFilters = {
    page: 1,
    subject_id: subject?.id,
    school_grade_id: subject?.school_grade_id,
    school_year_id: subject?.school_grade?.school_year_id,
    school_section_id: '',
    school_lapse_id: '',
    calification: CALIFICATION.INDIVIDUAL,
  };


  const user = useSelector(state => state.user);
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [lapses, setLapses] = useState([]);
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([])


  const toSelect = (items) => items.map(x => ({ ...x, value: String(x.id), label: x.name }));

  const fetchData = async () => {
    if (!canFetch || !filters.school_grade_id || !filters.school_section_id) return;
    setCanFetch(false);

    try {
      const students = await TeacherStudentSerivce.student.getStudents({
        user_id: user.id,
        school_grade_id: +filters.school_grade_id,
        school_section_id: +filters.school_section_id,
        perPage: 999
      });

      const { data } = students;

      setStudents(data);


      setCanFetch(true);

    } catch (error) {
      onError(String(error));
      setCanFetch(true);
    }
  }

  const fetchSelects = async () => {
    try {
      const selects = await TeacherAttendeceService.attendence.getSelects({ professor_id: user.id });
      setLapses(toSelect(selects.lapses));
      setSections(toSelect(selects.sections));
      setCanFetch(true)

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }


  const onError = (msg) => toast.error(msg);

  const filterBy = (value, target) => {
    setFilters({ ...filters, page: 1, [target]: value })
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const isValidForm = (description) => {
    if (!filters.school_section_id) {
      toast.error('Debe seleccionar una sección');
      return false;
    }

    if (!filters.school_lapse_id) {
      toast.error('Debe seleccionar un lapso');
      return false;
    }

    if (!description) {
      toast.error('Debe escribir una descripción');
      return false;
    }

    return true;
  }


  const onSaveIndividual = async (data) => {
    if (!isValidForm(data.description)) return;
    try {
      await TeacherConductService.conduct.createIndividualConduct({
        ...data,
        professor_id: user.id,
      });

      toast.success('Conducta tomada correctamente');
    } catch (error) {
      onError(String(error));
    }
  }

  const onSaveGroup = async (data) => {
    if (!isValidForm(data.description)) return;
    try {
      await TeacherConductService.conduct.createGroupConduct({
        ...data,
        professor_id: user.id,
      })

      toast.success('Conducta grupal tomada correctamente');
    } catch (error) {
      onError(String(error));
    }
  }

  useEffect(() => {
    fetchData();
  }, [filters.school_grade_id, filters.school_section_id]);


  useEffect(() => {
    fetchSelects();
  }, [])



  return {
    data,
    filterBy,
    filters,
    isLoading: !canFetch,
    sections: sections.filter(x => x.school_grade_id === +filters.school_grade_id),
    onSaveGroup,
    grades,
    lapses: lapses.filter(x => x.school_year_id === +filters.school_year_id),
    students,
    reload,
    onSaveIndividual,
  }
}

export default ConductsCreate;